import { BrowserRouter, Routes, Route, useSearchParams } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import { AppProvider } from "./lib/AppContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Landing from "./pages/Landing";
import Register from "./pages/Register";
import MemberDashboard from "./pages/MemberDashboard";
import Members from "./pages/Members";
import Home from "./pages/Home";
import Hunter from "./pages/Hunter";
import SignalHistory from "./pages/SignalHistory";
import Buyable from "./pages/Buyable";
import MyHoldings from "./pages/MyHoldings";
import Autonomous from "./pages/Autonomous";
import Terminal from "./pages/Terminal";
import Patterns from "./pages/Patterns";
import Predictive from "./pages/Predictive";
import { Portfolio, Positions, PaperTrading } from "./pages/Portfolio";
import Orders from "./pages/Orders";
import { DailyTarget, CapitalShield } from "./pages/Risk";
import Brokers from "./pages/Brokers";
import Backtesting from "./pages/Backtesting";
import Analytics from "./pages/Analytics";
import { Notifications, AuditLogs } from "./pages/Notifications";
import Settings from "./pages/Settings";
import Moomoo from "./pages/Moomoo";
import ChartPane from "./components/ChartPane";
import { useFetch } from "./lib/useFetch";
import { useState } from "react";
import { StaleBanner } from "./components/StaleBanner";

function ChartWindow() {
  const [p] = useSearchParams();
  const [symbol, setSymbol] = useState(p.get("symbol") || "AAPL");
  const [tf, setTf] = useState(p.get("tf") || "15m");
  const { data: uni } = useFetch("/universe");
  return (
    <div className="h-screen bg-white p-2" data-testid="chart-window">
      <ChartPane id="detached" symbol={symbol} tf={tf} universe={uni || []} onSymbol={setSymbol} onTf={setTf} overlays="ema21,ema50,vwap" height={window.innerHeight - 90} />
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/welcome" element={<Landing />} />
          <Route path="/register" element={<Register />} />
          <Route path="/member" element={<MemberDashboard />} />
          <Route path="/chart-window" element={<ChartWindow />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/hunter" element={<Hunter />} />
            <Route path="/signals" element={<SignalHistory />} />
            <Route path="/buyable" element={<Buyable />} />
            <Route path="/holdings" element={<MyHoldings />} />
            <Route path="/autonomous" element={<Autonomous />} />
            <Route path="/terminal" element={<Terminal />} />
            <Route path="/patterns" element={<Patterns />} />
            <Route path="/predictive" element={<Predictive />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/positions" element={<Positions />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/daily-target" element={<DailyTarget />} />
            <Route path="/capital-shield" element={<CapitalShield />} />
            <Route path="/brokers" element={<Brokers />} />
            <Route path="/moomoo" element={<Moomoo />} />
            <Route path="/backtesting" element={<Backtesting />} />
            <Route path="/paper-trading" element={<PaperTrading />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/audit-logs" element={<AuditLogs />} />
            <Route path="/members" element={<Members />} />
            <Route path="*" element={<div className="p-10 text-sm text-slate-600" data-testid="not-found">Page not found.</div>} />
          </Route>
        </Routes>
      </BrowserRouter>
      <StaleBanner />
      <Toaster theme="light" position="bottom-right" toastOptions={{ style: { background: "#FFFFFF", border: "1px solid #E2E8F0", color: "#0F172A" } }} />
    </AppProvider>
  );
}
